import { Pipe, PipeTransform } from '@angular/core';

import { isNewTagVisible } from '../helpers/new-tag.helper';

@Pipe({
  name: 'newTagVisible',
  standalone: true
})
export class NewTagVisiblePipe implements PipeTransform {
  transform(newUntil: string | undefined): boolean {
    return isNewTagVisible(newUntil);
  }
}
